import React, { useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { enqueueSnackbar } from "notistack";
import { api } from "../../../services/api";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../ui/card";
import { InputText } from "../../InputText";
import { Button } from "../../ui/button";
import { Label } from "../../ui/label";
import { Loader2, User, X } from "lucide-react";

const schema = Yup.object().shape({
  new_nick: Yup.string().required("Campo nick obrigatório"),
});

interface AlterarNickModalProps {
  isOpen: boolean;
  onClose: () => void;
  militarNick: string;
  onSuccess?: () => void;
}

export function AlterarNickModal({ isOpen, onClose, militarNick, onSuccess }: AlterarNickModalProps) {
  const [loading, setLoading] = useState(false);

  function handleSubmit(values: { nick: string; new_nick: string }) {
    setLoading(true);
    api
      .patch("/militares/updateNick", values)
      .then(() => {
        enqueueSnackbar("Nick alterado com sucesso!", {
          variant: "success",
        });
        onClose();
        if (onSuccess) {
          onSuccess();
        }
      })
      .catch(({ response }) => {
        enqueueSnackbar(response.data.message, {
          variant: "warning",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  const initialValues = {
    nick: militarNick,
    new_nick: militarNick,
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
          <div>
            <CardTitle className="flex items-center gap-2">
              <User className="h-5 w-5 text-[oklch(0.45_0.15_142)]" />
              Alterar Nick
            </CardTitle>
            <CardDescription>
              Altere o nick do militar: {militarNick}
            </CardDescription>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            className="h-6 w-6 p-0"
            disabled={loading}
          >
            <X className="h-4 w-4" />
          </Button>
        </CardHeader>
        <CardContent>
          <Formik
            initialValues={initialValues}
            validationSchema={schema}
            onSubmit={handleSubmit}
          >
            {({ errors, values, handleChange }) => (
              <Form className="space-y-4">
                <div>
                  <Label htmlFor="new_nick">Novo Nick</Label>
                  <InputText
                    id="new_nick"
                    name="new_nick"
                    title=""
                    placeholder="Digite o novo nick do militar"
                    value={values.new_nick}
                    onChange={handleChange}
                    error={errors.new_nick}
                    className="mt-1"
                    disabled={loading}
                  />
                </div>

                <div className="flex gap-2 pt-4">
                  <Button
                    type="button"
                    variant="outline"
                    onClick={onClose}
                    className="flex-1"
                    disabled={loading}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    disabled={loading}
                    className="flex-1 bg-[oklch(0.45_0.15_142)] hover:bg-[oklch(0.40_0.15_142)] text-white"
                  >
                    {loading ? (
                      <>
                        <Loader2 className="w-4 h-4 mr-2 animate-spin" />
                        Salvando...
                      </>
                    ) : (
                      "Salvar"
                    )}
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </CardContent>
      </Card>
    </div>
  );
}
